export default {
  WTD: 'WTD',
  MTD: 'MTD',
  QTD: 'QTD',
  YTD: 'YTD',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/net-sales/tabs.js